(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    (function () {
  var wrap = document.getElementById('kh-spin-wrap');
  var el   = document.getElementById('kh-spin');
  if (!el) return;
  var isMobile = window.matchMedia('(hover: none)').matches;
  if (!isMobile) return;
  var currentY = 0, targetY = 0, gyroActive = false, touchStart = null, rotStart = 0;
  (function loop() {
    currentY += (targetY - currentY) * 0.08;
    el.style.transform = 'rotateY(' + currentY + 'deg)';
    requestAnimationFrame(loop);
  })();
  function enableGyro() {
    gyroActive = true;
    window.addEventListener('deviceorientation', function (e) {
      if (e.gamma == null) return; targetY = e.gamma * 2;
    });
  }
  if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
    wrap.addEventListener('click', function handler() {
      DeviceOrientationEvent.requestPermission().then(function (s) { if (s === 'granted') enableGyro(); });
      wrap.removeEventListener('click', handler);
    });
  } else if (typeof DeviceOrientationEvent !== 'undefined') { enableGyro(); }
  el.addEventListener('touchstart', function (e) { if (gyroActive) return; touchStart = e.touches[0].clientX; rotStart = currentY; }, { passive: true });
  el.addEventListener('touchmove',  function (e) { if (gyroActive || touchStart === null) return; targetY = rotStart + (e.touches[0].clientX - touchStart) * 0.6; }, { passive: true });
  el.addEventListener('touchend',   function () { touchStart = null; }, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

})();
